'use strict';

export default {
	POS_CONFIGURATION_LAYOUT: 'Pos Configuration Layout',
	COMPONENT_MOUNTED_WARNING_MESSAGE:
		'Please close the existing open pos configuration layout to view this one',
};
